import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { MatchCardVoteFetcher } from './match-card-vote-fetcher';
import { EmptyState } from 'common/react/components/EmptyState';
import { useGetMatchesQuery } from 'common/store/modules/api/afl-api';
import { RoundByRoundSkeleton } from './Leaderboard/components/skeleton-loaders/RoundByRoundSkeleton';
import { ByesGroup } from 'common/react/components/ByesGroup';
import { useLeaderboardRefetch } from './hooks/use-leaderboard-refetch';
import { navSelector } from 'common/store/modules/competition-nav/selectors';

const LAST_BYE_ROUND = 23;

export const RoundByRoundCards = ({ shouldHidePredicted, startDateTime }) => {
    const nav = useSelector(navSelector);

    const params = {
        competition: nav.competition.id,
        compSeasonId: nav.season.id,
        roundNumber: nav.round.roundNumber,
        matchStatus: PULSE.app.common.CONSTANTS.MATCH_STATUS.CONCLUDED,
        pageSize: 50
    };

    const { data: matches = [], isFetching: isMatchesFetching } =
        useGetMatchesQuery(params, {
            skip:
                !params.competition ||
                !params.compSeasonId ||
                (!params.roundNumber && params.roundNumber !== 0)
        });

    useLeaderboardRefetch(
        nav.season?.providerId,
        PULSE.app.common.CONSTANTS.TIME.THIRTY_SECS_IN_MS,
        startDateTime
    );

    return isMatchesFetching ? (
        <div className="player-awards-round-by-round__loader">
            <RoundByRoundSkeleton />
        </div>
    ) : matches.length ? (
        <>
            <div className="player-awards-round-by-round__content">
                {matches.map((match) => (
                    <MatchCardVoteFetcher
                        key={match.id}
                        matchData={match}
                        seasonPid={nav.season.providerId}
                        seasonId={nav.season.id}
                        modifier="round-by-round"
                        playerModalEnabled={true}
                        shouldHidePredicted={shouldHidePredicted}
                    />
                ))}
            </div>

            {nav?.round !== null &&
            !isNaN(nav?.round) &&
            nav.round < LAST_BYE_ROUND &&
            nav.season.id ? (
                <ByesGroup
                    compseasonId={nav.season.id}
                    roundNumber={nav.round}
                />
            ) : null}
        </>
    ) : (
        <div className="player-awards-round-by-round__empty-state">
            <EmptyState
                titleTranslation="label.brownlow.rbr.error.noDataAvailable"
                summaryTranslation="label.brownlow.tracker.error.noDataAvailable.summary"
            />
        </div>
    );
};

RoundByRoundCards.propTypes = {
    shouldHidePredicted: PropTypes.bool,
    startDateTime: PropTypes.string
};
